module.exports = __webpack_public_path__ + "img/openfirehydrant_attached.72abc443.svg";